var path = '/templates/projects.settings/other/particular_event.html';
var html = "<div id=projectSettingsBase><h1 class=config-title>{{ 'projectsSettings.other.particularEvent.particularEvent' | translate }}</h1><p class=config-lead>{{ 'projectsSettings.other.particularEvent.description' | translate }}</p><section><zc-particular-event-editor project-id=project.id></zc-particular-event-editor></section></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ../enterprise/src/zenclerk_modules/projects.settings/other/particular_event.html
// module id = 1573
// module chunks = 0